import { securityQuestionsConstants } from "../_constants/securityQuestions.constant";
import { alertActions } from "./alert.actions";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";

export const securityQuestionsActions = {
  securityQuestionsList,
  updateSecurityQuestions,
  updateSecurityQuestionsStatus,
  addSecurityQuestions,
  deleteSecurityQuestions,
};

function securityQuestionsList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/securityQuestion/getSecurityQuestionList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_FAILURE,
      error,
    };
  }
}

function addSecurityQuestions(data, resData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/securityQuestion/createSecurityQuestion",
  };
  return APIcallFunction(credentials)
}

function updateSecurityQuestions(data, resData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/securityQuestion/updateSecurityQuestion",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user?.message));
        dispatch(securityQuestionsActions.securityQuestionsList(resData));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_FAILURE,
      error,
    };
  }
}

function updateSecurityQuestionsStatus(data, resD) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/securityQuestion/updateSecurityQuestionStatus",
  };
  return APIcallFunction(credentials)
}

function deleteSecurityQuestions(data, resData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/securityQuestion/deleteSecurityQuestion",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(securityQuestionsActions.securityQuestionsList(resData));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: securityQuestionsConstants.DELETE_SECURITYQUESTIONS_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: securityQuestionsConstants.DELETE_SECURITYQUESTIONS_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: securityQuestionsConstants.DELETE_SECURITYQUESTIONS_FAILURE,
      error,
    };
  }
}
